module.exports = {"components.errorMessage.message.default":"Une erreur inattendue s'est produite.","components.errorMessage.reload.buttonLabel":"recharger","components.errorMessage.message.contentItem1":"SVP","components.errorMessage.message.contentItem2":"la page"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/fr/components/ErrorMessage.json
// module id = 793
// module chunks = 0